import React, { useState, useRef, useCallback, useEffect } from "react";
import { TextField, SortMenu } from "@ann/web-components";
import {
  FiltersContainer,
  FiltersLeftContent,
  FiltersRightContent,
} from "./RolesFilters.styled";

const RolesFilters = ({
  onSortChange,
  onOrderChange,
  selectedSortOption = "createdAt",
  orderDirection = "desc",
  onSearchChange,
  loading = false,
}) => {
  const [searchValue, setSearchValue] = useState("");
  const searchTimeoutRef = useRef(null);

  const handleSearchChange = useCallback((value) => {
    setSearchValue(value);
    
    // Clear existing timeout
    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current);
    }
    
    // Set new timeout for 500ms debounce
    searchTimeoutRef.current = setTimeout(() => {
      if (onSearchChange) {
        onSearchChange(value);
      }
    }, 500);
  }, [onSearchChange]);

  // Cleanup timeout on unmount
  useEffect(() => {
    return () => {
      if (searchTimeoutRef.current) {
        clearTimeout(searchTimeoutRef.current);
      }
    };
  }, []);

  return (
    <FiltersContainer>
      <FiltersLeftContent>
        <TextField
          iconLeft="search"
          onChange={handleSearchChange}
          size="small"
          placeholder="Search"
          value={searchValue}
          disabled={loading}
        />
      </FiltersLeftContent>

      <FiltersRightContent>
        <SortMenu
          minWidth="200px"
          onChange={onSortChange || (() => {})}
          order={orderDirection.toLowerCase()}
          onOrderChange={onOrderChange || (() => {})}
          options={[
            {
              icon: 'clock',
              id: 'createdAt',
              label: 'Most Recent'
            },
            {
              icon: 'sortByAlpha',
              id: 'name',
              label: 'Name (A-Z)'
            },
            {
              icon: 'update',
              id: 'updatedAt',
              label: 'Last Updated'
            }
          ]}
          selected={selectedSortOption}
          size="medium"
          title="SORT BY"
          width="240px"
          disabled={loading}
        />
      </FiltersRightContent>
    </FiltersContainer>
  );
};

export default RolesFilters;

